module.exports = __webpack_public_path__ + "img/mario.4a52ea47.png";